import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button, CircularProgress, IconButton, Modal, Stack, Tooltip, Typography } from '@mui/material';
import { createErrorMessage, formatMoney } from '../../../../../utils';
import { useCancelPaymentMutation, useGetPaymentStatusQuery } from '../../../../../services/PaymentToolApi';
import {formatDateRangeToString, parseToEasternTime} from '../../../../../utils/dates';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNotification } from '../../../../../context/NotificationContext';
import BasicModalConfirmation from '../../../../../components/basicModalConfirmation';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const styleModal = ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '950px',
  height: '35vh',
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '1.5em',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  
  alignItems: 'center',
});

const TableHeaderInfo = {
  padding: '1em',
  margin: '0 0 1em 0',
  borderRadius: '1em',
  backgroundColor: 'white',
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'space-between'
}

function getTotalAmountAndFees(items){
  let totalAmount = 0;
  let totalFees = 0;
  items.forEach(item => {
    if(item.transaction_status === 'SUCCESS'){
      totalFees += parseFloat(item.payout_item_fee.value);
      totalAmount += parseFloat(item.payout_item.amount.value);
    }
  });
  return {totalAmount, totalFees};
}


function PaymentInformationHeader({ paymentStatusData }) {
  const lineStyle = {
      width: '100%',
      borderTop: '1px solid #000',
      margin: '1em 0',
  };

  let batchID = paymentStatusData?.paymentSyncHistory?.payoutBatchID;
  let createdOn = paymentStatusData?.paymentSyncHistory?.createdOn;
  let senderBatchID = paymentStatusData?.payoutBatchDetailsResponse?.batch_header?.sender_batch_header?.sender_batch_id;
  let batchStatus = paymentStatusData?.payoutBatchDetailsResponse?.batch_header?.batch_status;

  let {totalAmount, totalFees} = getTotalAmountAndFees(paymentStatusData?.payoutBatchDetailsResponse?.items);

  return (
      <div style={TableHeaderInfo}>
          
          <div style={{ display: 'flex', marginBottom: '0.5em' }}>
              <p style={{ fontWeight: '600', margin: '0', whiteSpace: 'nowrap' }}> <span style={{color: 'orange'}}> Period Date: </span> {formatDateRangeToString(paymentStatusData?.period?.startDate, paymentStatusData?.period?.endDate)}</p>
              <p style={{ fontWeight: '600', margin: '0 0 0 1em', whiteSpace: 'nowrap' }}><span style={{color: 'orange'}}> Period ID: </span> {paymentStatusData?.period?.id}</p>
          </div>

          <hr style={lineStyle} />

          <div>

            <div style={{ display: 'flex', marginBottom: '1em' }}>
                <p style={{ fontWeight: '600', margin: '0', whiteSpace: 'nowrap' }}> <span style={{color: 'orange'}}>Payout Batch ID: </span> {batchID}</p> 
                <p style={{ fontWeight: '600', margin: '0 0 0 1em', whiteSpace: 'nowrap' }}> <span style={{color: 'orange'}}>Batch Status:  </span> {batchStatus}</p>
                <p style={{ fontWeight: '600', margin: '0 0 0 1em', whiteSpace: 'nowrap' }}><span style={{color: 'orange'}}>Time Created: </span> {parseToEasternTime(createdOn)}</p>
                
            </div>

            <div style={{ display: 'flex' }}>
              <p style={{ fontWeight: '600',  whiteSpace: 'nowrap' }}><span style={{color: 'orange'}}>Sender Batch ID: </span> {senderBatchID}</p>
              <p style={{ fontWeight: '600',margin: '0 0 0 1em', whiteSpace: 'nowrap' }}><span style={{color: 'orange'}}>Amount Paid: </span>{formatMoney(totalAmount)}</p>
              <p style={{ fontWeight: '600', margin: '0 0 0 1em', whiteSpace: 'nowrap' }}><span style={{color: 'orange'}}>Fees Paid: </span> {formatMoney(totalFees)}</p>
            </div>
          </div>
          

          
      </div>
  )
}



export default function PaymentInformation({ periodID }) {

    const { showNotification } = useNotification();

    const history = useHistory();
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const { data: paymentStatusData, isLoading: paymentStatusIsLoading, isFetching: paymentStatusIsFetching, error: paymentStatusError } = useGetPaymentStatusQuery({ periodID });
    const [initCancelPayment, { isLoading: cancelPaymentIsLoading }] = useCancelPaymentMutation();
    const [showPaymentDataError, setShowPaymentDataError] = useState(false);

    async function onCancelPaymentClick(row){
      let reqobj={
        userID: row.payout_item.sender_item_id.split('-')[1],
        payoutItemID: row.payout_item_id,
        amount: row.payout_item.amount.value,
        periodID
      }
      try{
        let res= await initCancelPayment(reqobj).unwrap();
        console.log("CancelPayment Response: ", res); 
        showNotification('Payment Canceled!', 'success');
      }catch(err){
        console.log("CancelPayment error: ", err); 
        showNotification(createErrorMessage(err), 'error');
      }

    }

    function showErrorIcon(params){
        if(params.row.transaction_status === 'UNCLAIMED'){
          return <>
            <Tooltip title="View Payment Information" placement="top-start">
              <IconButton color="primary" onClick={()=> setShowPaymentDataError(params.row)}>
                <InfoOutlinedIcon />
              </IconButton>
            </Tooltip>
            
            <Tooltip title="Cancel Payment" placement="top-start">
            <IconButton variant='contained' color='error' onClick={() => setShowConfirmationModal(params.row)}><CancelOutlinedIcon/></IconButton>
            </Tooltip>
          </>
        }
        if(params.row.transaction_status !== 'SUCCESS'){
            return <Tooltip title="View Payment Information" placement="top-start">
            <IconButton color="primary" onClick={()=> setShowPaymentDataError(params.row)}>
              <InfoOutlinedIcon />
            </IconButton>
          </Tooltip>
        }
    }

    const [columns, setColumns] = React.useState([
        {field: 'id', headerName: 'ID', hide: true, flex: 0.5, valueGetter: (params) => params.row.payout_item_id},
        {field: 'fullName' , headerName: 'FULLNAME', valueGetter: (params) => params.row.fullName, flex: 1.5},
        {field: 'email', headerName: 'EMAIL', valueGetter: (params) => params.row.payout_item?.receiver, flex: 1.5},
        {field: 'PAYOUT ID', headerName: 'PAYOUT ID', valueGetter: (params) => params.row.payout_item_id, flex: 1},
        {field: 'AMOUNT', headerName: 'AMOUNT', valueGetter: (params) => formatMoney(params.row.payout_item?.amount?.value), flex: 1},
        {field: 'STATUS', headerName: 'STATUS', valueGetter: (params) => params.row.transaction_status, flex: 1},
        {field: 'TIME PROCESSED', headerName: 'TIME PROCESSED', valueGetter: (params) => parseToEasternTime(params.row.time_processed), flex: 1},
        {field: 'PAYOUT ITEM FEE', headerName: 'PAYOUT ITEM FEE', valueGetter: (params) => formatMoney(params.row.payout_item_fee.value), flex: 1},
        {field: 'iconInfo', headerName: '', flex: 1, renderCell: showErrorIcon}
    ]);



    if(paymentStatusIsLoading){
        return <CircularProgress />
    }else if (paymentStatusError){
        return <div>Error: {createErrorMessage(paymentStatusError)}</div>
    }

    return (
        <div style={{height:'70vh'}}>
            {/* create a flex with two columns one for title al in the left an another for 'go back' button all rigth */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1em' }}>
                <Typography variant='h5' style={{ fontWeight: '600' }}>PayPal payments details</Typography>
                <Button onClick={() => history.push("/dashboard/admintools?tab_index=4") } variant="contained" color="primary">
                    Back To Honeypot Manager
                </Button>
            </div>

            
            <PaymentInformationHeader paymentStatusData={paymentStatusData}/>


            <DataGridPremium
              sx={{ height:'59vh' }}
              rows={(paymentStatusData?.payoutBatchDetailsResponse?.items || [])} columns={columns}
              loading={paymentStatusIsLoading || paymentStatusIsFetching || cancelPaymentIsLoading}
              disableSelectionOnClick
              getRowId={(row) => row.payout_item_id}          
            />

            <Modal
                open={showPaymentDataError}
                onClose={() => setShowPaymentDataError(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleModal}>
                  <Stack direction="row" alignItems="center" gap={1}>
                    <InfoOutlinedIcon sx={{ color: 'var(--red)', fontSize: '32px' }} />
                    <Typography id="modal-modal-description" sx={{ fontWeight: '700', color: 'var(--red)' }} align="center" >
                     {showPaymentDataError?.errors?.name || showPaymentDataError?.transaction_status || 'Error'}
                    </Typography>
                  </Stack>

                  <p style={{marginTop: '1em', marginBottom: '1em'}}>
                    {showPaymentDataError?.errors?.message}
                    {showPaymentDataError?.errors?.details && showPaymentDataError?.errors?.details.length > 0 && showPaymentDataError?.errors?.details.map((detail, index) =>(
                      <>
                        <p>{detail.field} : {detail.value}</p>
                        <p>{detail.description}</p>
                      </>
                    ))}
                  </p>
                  
                  <div className='basic-modal-button'>
                    <Button variant='contained' style={{ width: '100px' }} onClick={() => setShowPaymentDataError(false)}>Close</Button>
                  </div>
                  
                </Box>
            </Modal>

            <BasicModalConfirmation
              title={`Are you sure you want to delete This Payment?`}
              confirmLabel={"Yes"}
              cancelLabel={"No"}
              open={showConfirmationModal}
              onClick={() => {
                onCancelPaymentClick(showConfirmationModal) //A: in showConfirmationModal we saved the row that the user clicked
              }}
              handleClose={() => setShowConfirmationModal(false)}
            />
            
        </div>
    );
}
